import { ReportPage } from 'types/reporting/reportPage';
import {
    HoursByEmployeeAndDayRow,
    HoursByEmployeeAndDayTotals,
    ProductivityByEmployeeAndCaseRow,
    ProductivityByEmployeeAndCaseTotals,
    ProductivityByEmployeeRow,
    ProductivityByEmployeeTotals,
    WorkingTimeByEmployeeRow,
    WorkingTimeByEmployeeTotals,
} from 'types/reporting/performance';
import { portalAPI } from './portalAPI';
import { reportQuery } from './util/reportQuery';

const reportingPerformanceApi = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        getProductivityByEmployeeReport: reportQuery<
            ReportPage<ProductivityByEmployeeRow, ProductivityByEmployeeTotals>
        >(builder, '/v1/reporting/productivity-by-employee'),
        getProductivityByEmployeeAndCaseReport: reportQuery<
            ReportPage<ProductivityByEmployeeAndCaseRow, ProductivityByEmployeeAndCaseTotals>
        >(builder, '/v1/reporting/productivity-by-employee-and-case'),
        getWorkingTimeByEmployeeReport: reportQuery<ReportPage<WorkingTimeByEmployeeRow, WorkingTimeByEmployeeTotals>>(
            builder,
            '/v1/reporting/working-time-by-employee'
        ),
        getHoursByEmployeeAndDayReport: reportQuery<ReportPage<HoursByEmployeeAndDayRow, HoursByEmployeeAndDayTotals>>(
            builder,
            '/v1/reporting/hours-by-employee-and-day'
        ),
    }),
});

export const {
    useLazyGetProductivityByEmployeeReportQuery,
    useLazyGetProductivityByEmployeeAndCaseReportQuery,
    useLazyGetWorkingTimeByEmployeeReportQuery,
    useLazyGetHoursByEmployeeAndDayReportQuery,
} = reportingPerformanceApi;
